export default __webpack_public_path__ + "static/media/perfect.8ba568bd.mp3";